module.exports = __webpack_public_path__ + "static/media/shield.0149f542.svg";